export default "__VITE_ASSET__wlpt8bBu__"